import { render } from "./template.vue?vue&type=template&id=e123001e&scoped=true"
const script = {}

import "./template.vue?vue&type=style&index=0&id=e123001e&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e123001e"]])

export default __exports__